// P2b tanda 5 — tabla de medidas de la guía de tallas: normalización con las
// MISMAS reglas de vitrina_normalizar_tabla (contrato v0.7.156): al menos una
// columna con nombre y una fila con talla; una columna con etiqueta vacía se
// descarta JUNTO con el valor de esa posición en cada fila; una fila sin talla
// se descarta; los valores se alinean POR POSICIÓN con las columnas. La tabla
// viaja SIEMPRE como objeto JSON {columnas, filas}, nunca JSON-en-string.

export function normalizarTabla(tabla) {
  const t = tabla || {};
  const crudas = Array.isArray(t.columnas) ? t.columnas.map((c) => String(c == null ? '' : c).trim()) : [];
  const vivas = [];
  crudas.forEach((c, i) => { if (c) vivas.push(i); });
  const columnas = vivas.map((i) => crudas[i]);
  const filas = (Array.isArray(t.filas) ? t.filas : [])
    .map((f) => {
      const valores = Array.isArray(f && f.valores) ? f.valores : [];
      return {
        talla: String((f && f.talla) == null ? '' : f.talla).trim(),
        valores: vivas.map((i) => String(valores[i] == null ? '' : valores[i]).trim()),
      };
    })
    .filter((f) => f.talla);
  if (!columnas.length || !filas.length) return null;
  return { columnas, filas };
}

// Forma editable vacía (una columna y una fila para empezar a tipear).
export function tablaVacia() {
  return { columnas: [''], filas: [{ talla: '', valores: [''] }] };
}

// Tanda 5b — pegado tipo Excel: tabulador = columnas, salto de línea = filas,
// aplicado desde la celda (fila, col); col -1 es la columna Talla. Expande
// FILAS si el pegado se sale hacia abajo y COLUMNAS hacia la derecha (las
// columnas nuevas nacen SIN nombre: quedan a la vista para nombrarlas, y el
// guardado las descarta si siguen vacías — regla del saneo del theme).
export function aplicarPegado(tabla, { fila, col }, texto) {
  const lineas = String(texto || '').replace(/\r/g, '').split('\n');
  while (lineas.length && lineas[lineas.length - 1] === '') lineas.pop(); // Excel cierra con \n
  if (!lineas.length) return tabla;
  const grid = lineas.map((l) => l.split('\t'));
  const columnas = [...((tabla && tabla.columnas) || [])];
  let filas = ((tabla && tabla.filas) || []).map((f) => ({ talla: f.talla, valores: [...(f.valores || [])] }));
  for (let r = 0; r < grid.length; r++) {
    const fi = fila + r;
    while (filas.length <= fi) filas.push({ talla: '', valores: [] });
    for (let c = 0; c < grid[r].length; c++) {
      const destino = col + c;
      if (destino === -1) {
        filas[fi].talla = grid[r][c];
      } else {
        while (columnas.length <= destino) columnas.push('');
        filas[fi].valores[destino] = grid[r][c];
      }
    }
  }
  filas = filas.map((f) => ({ talla: f.talla, valores: columnas.map((_, j) => (f.valores[j] == null ? '' : f.valores[j])) }));
  return { columnas, filas };
}

// El origen del árbitro del theme → texto en lenguaje claro para la ficha
// (contrato v0.7.156, GET /productos/{id}/guia).
export function textoDeOrigen(resolucion) {
  const r = resolucion || {};
  switch (r.origen) {
    case 'categoria': return `Usa la guía de su categoría: ${r.categoria || r.titulo || ''}`.trim();
    case 'producto': return `Usa la guía asignada a este producto: ${r.titulo || ''}`.trim();
    case 'propia': return 'Tiene tabla propia';
    case 'ninguna': return 'Sin guía: la categoría no tiene ninguna';
    default: return '';
  }
}
